module.exports = __webpack_public_path__ + "static/media/cv_cartagena.45f34394.jpg";